/* eslint-disable */
import { useEffect, useRef } from 'react'
import scrollEventFn from '../scroll_event'
export default function Ceo(){
  // scroll event
  const scroll01 = useRef(null)
  const scroll02 = useRef(null)
  const scroll03 = useRef(null)
  const scrollArr = [
    scroll01,
    scroll02,
    scroll03,
  ]
  useEffect(() => {
    window.scrollTo({top : 0, behavior : 'smooth'})
    // scroll event
    scrollEventFn(scrollArr)
    window.addEventListener("scroll", () => {scrollEventFn(scrollArr)})
    return () => {
      window.removeEventListener("scroll", () => {scrollEventFn(scrollArr)})
    }
  }, [])
  // html
  return(
    <div className="contents">
      <div className="content-title02">CEO 인사말</div>
      <div className="content-ceo">
        <div className="ceoImgBox" style={{backgroundImage:`url('/img/ceo.png')`}}></div>
        <div className="content-ceo-right">
          <p className="content-title01 scrollBox" ref={scroll01}>
            ㈜DX손해사정법인은 차별화된 시스템을 바탕으로 공정하고 정확한 손해사정업무를 수행하는 손해사정전문법인입니다.
          </p>
          <p className="content-text scrollBox" ref={scroll02}>
            ㈜DX손해사정법인은 '약관 기반 지급보험금 산출 솔루션(MagicClaim)'을 기반으로 정확성과 효율성을 높인 보험금 심사 및 지급업무가 가능한 국내 최고의 손해사정회사로 성장하고 있습니다.
          </p>
          <p className="content-text scrollBox" ref={scroll03}>
            ㈜DX손해사정법인은 고객의 신뢰를 최우선 가치로 추구하며, 앞으로도 더 많은 전문인력 양성과 시스템 고도화를 통해 고품질의 손해사정 서비스를 제공하도록 노력하겠습니다.
          </p>
        </div>
      </div>
    </div>
  )
}